import React from 'react'
import { View } from 'styles/reactnative'

import { column_group_detail } from '../../../components/AdminUserModal/UserInfoTabs/column_coingroup_detail'
import TableAPI from '../../../components/TableAPI'
import { Button } from 'antd'

const CoinGroupDetail = ({ title, type }: any) => {
	const [show, setshow] = React.useState(false)

	return (
		<View style={{ width: '100%' }}>
			{!show && (
				<Button
					onClick={() => {
						setshow(true)
					}}
					style={{ width: '100%' }}>
					데이터 보기
				</Button>
			)}
			<TableAPI
				stitle={title}
				columns={column_group_detail}
				usermodal={true}
				height={show ? 'default' : 10}
				apikey={
					show
						? `/admin/exchange?type=1&t='
				}`
						: null
				}
			/>
		</View>
	)
}

export default React.memo(CoinGroupDetail)
